/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Obtenir un token admin
     * Connexion d'un administrateur Solis (`email`, `password`). Renvoie `{ token, tokenable_type, tokenable_id, company_id: 0 }` ; le token se passe en `Authorization: Bearer` sur `/admin*` et est accepte partout ou un token personnel est attendu. 422 si les identifiants sont faux. Aucune `Company-Key` requise.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public createAdminToken(
        requestBody: {
            email: string;
            password: string;
        },
    ): CancelablePromise<{
        token: string;
        tokenable_type: string;
        tokenable_id: string;
        company_id: number;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Se connecter en tant qu'un personnel
     * Genere un token **personnel** pour `personnel_id` de l'entreprise `Company-Key`, marque comme usurpation. Permet de voir l'application exactement comme cet utilisateur. Reponse : meme forme que `POST /lolapp/login`.
     * @param personnelId
     * @returns any
     * @throws ApiError
     */
    public impersonatePersonnel(
        personnelId: string,
    ): CancelablePromise<{
        token: string;
        tokenable_type: string;
        tokenable_id: string;
        company_id: number;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/impersonate/{personnel_id}',
            path: {
                'personnel_id': personnelId,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Se connecter en tant qu'un client
     * Genere un token **client** pour `client_id` de l'entreprise `Company-Key`, pour voir l'espace client a sa place. Reponse : `{ token, tokenable_type, tokenable_id, company_id }`.
     * @param clientId
     * @returns any
     * @throws ApiError
     */
    public adminImpersonateClient(
        clientId: string,
    ): CancelablePromise<{
        token: string;
        tokenable_type: string;
        tokenable_id: string;
        company_id: number;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/impersonate_client/{client_id}',
            path: {
                'client_id': clientId,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
